import ProductsManagement from './products_management.vue';

export default ProductsManagement;
